import CandidatePlacedIcon from "@assets/svg/CandidatePlacedIcon";
import CommissionIcon from "@assets/svg/CommissionIcon";
import EmailSuccess from "@assets/svg/EmailSuccess";
import InvitationAcceptedIcon from "@assets/svg/InvitationAcceptedIcon";
import InviteReceived from "@assets/svg/InviteReceived";
// @ts-ignore
import ProfileImg from "@assets/images/profilepic.png";
// @ts-ignore
import AgencyImg from "@assets/images/agency.jpg";
// @ts-ignore
import GoogleImg from "@assets/images/google.jpg";
import CalenderIcon from "@assets/svg/CalenderIcon";
import AssessmentIcon from "@assets/svg/AssessmentIcon";
import EyeIcon from "@assets/svg/EyeIcon";
import EditIcon from "@assets/svg/EditIcon";
import ProfileIcon from "@assets/svg/ProfileIcon";
import TickThinOutline from "@assets/svg/TickThinOutline";
import JobMatchesIcon from "@assets/svg/JobMatchesIcon";
import { Briefcase, Calendar1, LogOut, StarIcon, UserIcon } from "lucide-react";
import dayjs from "dayjs";
import MembersIcon from "@assets/svg/MembersIcon";
import { useEffect, useState } from "react";
import { getActivityTracker } from "@endpoints/activityTracker/activityTracker.service";
import SkeletonTrackerList from "./components/SkeletonTrackerList";
import TrackIcon from "@assets/svg/TrackIcon";
import { EnumActivityTracker } from "@utils/constants";
import { IActivityTracker } from "@endpoints/types/activityTracker.type";
import TickCirckeIcon from "@assets/svg/TickCirckeIcon";
import MailOpenIcon from "@assets/svg/MailOpenIcon";
import JobPostedIcon from "@assets/svg/JobPostedIcon";
import store from "@store/index";
import MatchedIcon from "@assets/svg/MatchedIcon";
import BlueGroupIcon from "@assets/svg/BlueGroupIcon";
import PencilBoldIcon from "@assets/svg/PencilBoldIcon";

const BoldText = ({ children }) => {
  return <span className="font-semibold text-gray-500">{children}</span>;
};
const BaseText = ({ children }) => {
  return <span className="font-semibold text-gray-500">{children}</span>;
};

function getIcon(type: EnumActivityTracker, data: IActivityTracker) {
  switch (type) {
    case EnumActivityTracker.CANDIDATE_APPLIED:
      return <TickCirckeIcon className={"w-5 h-5"} />;
    case EnumActivityTracker.SUBMIT_OFFER:
      return <MailOpenIcon className={"w-5 h-5"} />;
    case EnumActivityTracker.JOB_POSTED:
      return <JobPostedIcon className={"w-5 h-5"} />;
    case EnumActivityTracker.JOB_MATCHES:
      return <MatchedIcon className={"w-5 h-5"} />;
    case EnumActivityTracker.PROFILE_UPDATED:
      return <PencilBoldIcon className={"w-5 h-5"} />;
    case EnumActivityTracker.JOB_REQUIREMENT_POSTED:
      return <JobPostedIcon className={"w-5 h-5"} />;
    case EnumActivityTracker.SUCCESSFUL_PLACEMENT:
      return <StarIcon className={"w-5 h-5"} color="#2e2e2e" />;
    case EnumActivityTracker.INTERVIEW_INVITATION:
      return <Calendar1 className={"w-5 h-5"} color="#2e2e2e" />;
    default:
      return <CommissionIcon className={"w-4 h-4"} fill="#2e2e2e" />;
  }
}
function getTitle(type: EnumActivityTracker, data: IActivityTracker) {
  switch (type) {
    case EnumActivityTracker.CANDIDATE_APPLIED:
      return "Applied";
    case EnumActivityTracker.SUBMIT_OFFER:
      return "Offer";
    case EnumActivityTracker.JOB_POSTED:
      return "Job posted";
    case EnumActivityTracker.JOB_MATCHES:
      return "Matched";
    case EnumActivityTracker.PROFILE_UPDATED:
      return "Profile Edit";
    case EnumActivityTracker.JOB_REQUIREMENT_POSTED:
      return "Requirement posted";
    case EnumActivityTracker.SUCCESSFUL_PLACEMENT:
      return "Successfully placed";
    case EnumActivityTracker.INTERVIEW_INVITATION:
      return "Interview";
    default:
      return data?.eventType + " - UI Missing";
  }
}

function getDescImage(type: EnumActivityTracker, data: IActivityTracker) {
  const user = store.getState()?.auth?.user;
  switch (type) {
    case EnumActivityTracker.CANDIDATE_APPLIED:
      return data?.candidateId?.profilePic ? (
        <img
          src={data?.candidateId?.profilePic}
          className="w-6 h-6 rounded-full"
        />
      ) : (
        <div className="w-6 h-6 rounded-full bg-gray-200 font-semibold flex justify-center items-center">
          {data?.candidateId?.firstName?.charAt(0)}
        </div>
      );
    case EnumActivityTracker.SUBMIT_OFFER:
      return data?.hiringCompanyId?.profilePic ? (
        <img
          src={data?.hiringCompanyId?.profilePic}
          className="w-6 h-6 rounded-full"
        />
      ) : (
        <div className="w-6 h-6 rounded-full bg-gray-200 font-semibold flex justify-center items-center">
          {data?.hiringCompanyId?.companyName?.charAt(0)}
        </div>
      );
    case EnumActivityTracker.JOB_POSTED:
      return user?.profilePic ? (
        <img src={user?.profilePic} className="w-6 h-6 rounded-full" />
      ) : (
        <div className="w-6 h-6 rounded-full bg-gray-200 font-semibold flex justify-center items-center">
          {user?.firstName?.charAt(0)}
        </div>
      );
    case EnumActivityTracker.JOB_MATCHES:
      return <BlueGroupIcon className="w-8 h-8" />;
    case EnumActivityTracker.PROFILE_UPDATED:
      return user?.profilePic ? (
        <img src={user?.profilePic} className="w-6 h-6 rounded-full" />
      ) : (
        <div className="w-6 h-6 rounded-full bg-gray-200 font-semibold flex justify-center items-center">
          {user?.firstName?.charAt(0)}
        </div>
      );
    case EnumActivityTracker.JOB_REQUIREMENT_POSTED:
      return data?.hiringCompanyId?.profilePic ? (
        <img
          src={data?.hiringCompanyId?.profilePic}
          className="w-6 h-6 rounded-full"
        />
      ) : (
        <div className="w-6 h-6 rounded-full bg-gray-200 font-semibold flex justify-center items-center">
          {data?.hiringCompanyId?.companyName?.charAt(0)}
        </div>
      );
    case EnumActivityTracker.SUCCESSFUL_PLACEMENT:
      return data?.candidateId?.profilePic ? (
        <img
          src={data?.candidateId?.profilePic}
          className="w-6 h-6 rounded-full"
        />
      ) : (
        <div className="w-6 h-6 rounded-full bg-gray-200 font-semibold flex justify-center items-center">
          {data?.candidateId?.firstName?.charAt(0)}
        </div>
      );
    case EnumActivityTracker.INTERVIEW_INVITATION:
      return data?.hiringCompanyId?.profilePic ? (
        <img
          src={data?.hiringCompanyId?.profilePic}
          className="w-6 h-6 rounded-full"
        />
      ) : (
        <div className="w-6 h-6 rounded-full bg-gray-200 font-semibold flex justify-center items-center">
          {data?.hiringCompanyId?.companyName?.charAt(0)}
        </div>
      );

    default:
      return <img src={ProfileImg} className="w-6 h-6 rounded-full" />;
  }
}

function getDescription(type: EnumActivityTracker, data: IActivityTracker) {
  switch (type) {
    case EnumActivityTracker.CANDIDATE_APPLIED:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>
            {data?.candidateId?.firstName} {data?.candidateId?.lastName}
          </BoldText>
          applied for the job titled
          <BoldText>{data?.jobId?.title} </BoldText>
          for the requirement submitted by
          <BoldText>{data?.hiringCompanyId?.companyName}.</BoldText>
        </span>
      );

    case EnumActivityTracker.SUBMIT_OFFER:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>{data?.hiringCompanyId?.companyName}</BoldText>
          submitted an offer to
          {data?.candidateId?.profilePic ? (
            <img
              src={data?.candidateId?.profilePic}
              className="w-6 h-6 rounded-full"
            />
          ) : (
            <div className="w-6 h-6 rounded-full bg-gray-200 font-semibold flex justify-center items-center">
              {data?.candidateId?.firstName?.charAt(0)}
            </div>
          )}
          <BoldText>
            {data?.candidateId?.firstName} {data?.candidateId?.lastName}
          </BoldText>
          for the requirement titled
          <BoldText>{data?.jobRequirementId?.title}.</BoldText>
        </span>
      );
    case EnumActivityTracker.JOB_POSTED:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>You</BoldText>
          posted a new job titled
          <BoldText>{data?.jobRequirementId?.title}</BoldText>
          from a requirement submitted by
          <BoldText>{data?.hiringCompanyId?.companyName}.</BoldText>
        </span>
      );
    case EnumActivityTracker.JOB_MATCHES:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <span>
            {data?.metadata?.totalMatchedCandidates} candidates have been
            matched for Job post titled
          </span>
          <BoldText>{data?.jobRequirementId?.title}</BoldText>
          <span>from a requirement submitted by</span>
          <BoldText>{data?.hiringCompanyId?.companyName}</BoldText>
        </span>
      );
    case EnumActivityTracker.PROFILE_UPDATED:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>You </BoldText>
          successfully updated your skills.
        </span>
      );
    case EnumActivityTracker.JOB_REQUIREMENT_POSTED:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>{data?.hiringCompanyId?.companyName}</BoldText>
          <span>has posted a job for your requirement titled</span>
          <BoldText>{data?.jobRequirementId?.title}.</BoldText>
        </span>
      );
    case EnumActivityTracker.SUCCESSFUL_PLACEMENT:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>
            {data?.candidateId?.firstName} {data?.candidateId?.lastName}
          </BoldText>
          <span>has been successfully placed at</span>
          <BoldText>{data?.hiringCompanyId?.companyName}</BoldText>
          for a requirement titled
          <BoldText>{data?.jobRequirementId?.title}.</BoldText>
        </span>
      );
    case EnumActivityTracker.INTERVIEW_INVITATION:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>{data?.hiringCompanyId?.companyName}</BoldText>
          <span>has requested an interview with</span>
          <BoldText>
            {data?.candidateId?.firstName} {data?.candidateId?.lastName}
          </BoldText>
          for a requirement titled
          <BoldText>{data?.jobRequirementId?.title}.</BoldText>
        </span>
      );

    case EnumActivityTracker.OFFER_RECEIVED:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>{data?.recruiterAgencyId?.companyName} </BoldText>
          sent you an offer from{" "}
          <BoldText>{data?.hiringCompanyId?.companyName} </BoldText>
          regarding
          <BoldText>{data?.jobId?.title}.</BoldText>
        </span>
      );
    case EnumActivityTracker.INTERVIEW_INVITE_SENT:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>ABC Recruitment </BoldText>
          has sent you an <BoldText>interview invitation </BoldText>
          for
          <BoldText>11am Monday 20th October 2025.</BoldText>
        </span>
      );
    case EnumActivityTracker.MEETING_FORWARDED:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>{data?.recruiterAgencyId?.companyName} </BoldText>
          has sent you an <BoldText>availability poll. </BoldText>
        </span>
      );
    case EnumActivityTracker.CANDIDATE_SHORTLISTED:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>Google Inc </BoldText>
          has shortlisted your application for the position
          <BoldText>React Frontend Developer.</BoldText>
        </span>
      );
    case EnumActivityTracker.SHORTLIST_BY_RECRUITER_AGENCY:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>{data?.recruiterAgencyId?.companyName}</BoldText>
          has shortlisted your application for the position
          <BoldText>{data?.jobId?.title}.</BoldText>
        </span>
      );
    case EnumActivityTracker.APPLICATION_SUBMITTED:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>{data?.recruiterAgencyId?.companyName}</BoldText>
          has submitted your application to
          <BoldText>{data?.hiringCompanyId?.companyName}</BoldText>
          for the position titled <BoldText>{data?.jobId?.title}.</BoldText>
        </span>
      );
    case EnumActivityTracker.APPLICATION_VIEWED:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>{data?.recruiterAgencyId?.companyName} </BoldText>
          has viewed your application for the position
          <BoldText>{data?.jobId?.title}. </BoldText>
        </span>
      );
    case EnumActivityTracker.PROFILE_UPDATED:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>You </BoldText>
          successfully updated your skills.
        </span>
      );
    case EnumActivityTracker.USER_REGISTERED:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>You </BoldText>
          registered successfully on COMTRACKED.
        </span>
      );
    default:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-light-black">
          <BoldText>ABC Recruitment </BoldText>
          sent you an offer from <BoldText>ABC Recruitment </BoldText>
          regarding
          <BoldText>ABC Recruitment.</BoldText>
        </span>
      );
  }
}

type CardProps = {
  type: EnumActivityTracker;
  data: IActivityTracker;
};

const Card = ({ type, data }: CardProps) => {
  return (
    <div className="flex gap-5">
      <div className="flex items-center justify-center w-11 h-11 rounded-md bg-gray-100">
        {getIcon(type, data)}
      </div>
      <div className="flex flex-col gap-1 w-full">
        <span className="font-semibold text-xs gap-5 flex text-primary">
          {getTitle(type, data)}
          <span className="font-medium text-light-black">
            {dayjs(data?.createdAt).format("hh:mm a, dddd DD MMM")}
          </span>
        </span>
        <div className="flex text-xs text-primary bg-[#fafafa] w-full rounded-md p-3 gap-3">
          {getDescImage(type, data)}
          <div className="mt-[0.2rem]">{getDescription(type, data)}</div>
        </div>
      </div>
    </div>
  );
};

const RecruiterTrackerPage = () => {
  const [acitvities, setAcitvities] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchActivityTracker = async () => {
    try {
      setIsLoading(true);
      const { data, success } = await getActivityTracker();
      if (success && data) {
        setAcitvities(data?.data);
      }
    } catch (error) {
      console.error("Error: fetching activity trackers", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchActivityTracker();
  }, []);

  return (
    <div className="flex flex-col flex-1 min-h-0 rounded-md bg-white p-5">
      <span className="font-bold text-primary mx-auto">Activity Tracker</span>

      {/* Tracker List */}
      <div className="flex flex-col min-h-0 mb-5 mt-8 w-[60%] mx-auto gap-6 overflow-y-scroll no-scrollbar">
        {isLoading ? (
          <SkeletonTrackerList />
        ) : acitvities?.length ? (
          acitvities?.map((activity) => {
            return <Card type={activity?.eventType} data={activity} />;
          })
        ) : (
          <div className="flex-col gap-3 m-auto h-[90vh] flex justify-center items-center font-medium text-light-black text-sm">
            <TrackIcon className={"w-16 h-16"} fill={"gray"} />
            No acitvities recorded till now.
          </div>
        )}
        {/* <Card type="referralFee" />
        <Card type="offerAccepted" />
        <Card type="offerAccepted" />
        <Card type="offer" />
        <Card type="invitation" />
        <Card type="poll" />
        <Card type="shortlist" />
        <Card type="view" />
        <Card type="jobPosted" />
        <Card type="matched" />
        <Card type="applied" />
        <Card type="jobPosted" />
        <Card type="requirementPosted" />
        <Card type="companyAdd" />
        <Card type="edit" />
        <Card type="register" /> */}
      </div>
    </div>
  );
};

export default RecruiterTrackerPage;
